import { Dialog, DialogContent, DialogTitle, Typography } from '@mui/material';
import { useCallback, useState } from 'react';
import { Route, Routes } from 'react-router-dom';
import { usePWAInstall } from 'react-use-pwa-install';
import AdminRouter from './components/AdminRouter';
import PrimaryButton from './components/PrimaryButton';
import { t } from './constants/translations';
import { AdminProvider } from './contexts/admin.context';
import { CafeProvider } from './contexts/cafe.context';
import { useLocale } from './contexts/locale.context';
import { UserProvider } from './contexts/user.context';
import CreationPage from './pages/CreationPage';
import WelcomePage from './pages/WelcomePage/WelcomePage';

const AppRouter = () => {
  const installPWA = usePWAInstall();
  const [inBrowser, setInBrowser] = useState(false);
  const { lang } = useLocale();

  const handleClose = useCallback(() => {
    setInBrowser(true);
  }, []);

  return (
    <>
      <UserProvider>
        <Routes>
          <Route path="/">
            <Route index element={<WelcomePage />} />
            <Route path="create" element={<CreationPage />} />
            <Route
              path=":cafeSlug/*"
              element={
                <AdminProvider>
                  <CafeProvider>
                    <AdminRouter />
                  </CafeProvider>
                </AdminProvider>
              }
            />
          </Route>
        </Routes>
      </UserProvider>

      {!inBrowser && Boolean(installPWA) && (
        <Dialog open onClose={handleClose} maxWidth="xs">
          <DialogTitle>{t.welcome_to_firemenu[lang]}</DialogTitle>

          <DialogContent>
            <Typography sx={{ mb: 3 }}>{t.firemenu_works_in_browser[lang]}</Typography>

            <PrimaryButton sx={{ mb: 1 }} fullWidth onClick={handleClose}>
              {t.continue_in_browser[lang]}
            </PrimaryButton>

            <PrimaryButton fullWidth onClick={installPWA} variant="contained">
              {t.install_the_app[lang]}
            </PrimaryButton>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default AppRouter;
